import { Injectable } from '@angular/core';
import { NavMenu, NavMenuItem } from '@caslink/common-client';

@Injectable({
    providedIn: 'root'
})
export class NavigationService {
    // Empty, you should inject your own implementation of navigation service if needed (e.g. in CasLink)

    getNavMenuMetadata(): NavMenu {
         return null;
    }

    getNavMenuItemByKey(key: string): NavMenuItem {
        return null;
    }

    getNavMenuItemByStateName(name: string): NavMenuItem {
        return null;
    }

    getNavMenuItemByStateData(data: any): NavMenuItem {
        return null;
    }

    getRootMenuItem(menuItem: NavMenuItem): NavMenuItem {
        return null;
    }

    menuItemSelected(controller: any, menuItem: NavMenuItem, reload?: boolean) {
        return null;
    }

    initNavMenuMetadata(): NavMenu {
        return null;
    }

    setupMenuItem(loadedLocationId: number, menuItem: NavMenuItem) {
        return null;
    }

    setupMenuItems(loadedLocationId: number, menu: NavMenu) {
        return null;
    }

    setupNavigation(event, toState, toParams) {
        return null;
    }

    updateNavigationStructure(loadedLocationId: number) {
        return null;
    }
}
